import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "shared/utils/firebase";
import styles from './desknavBar.module.css';
import SmartLink from "./SmartLink";
import { getAbsoluteUrl, isSameSite } from "../../utils/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faCog,
  faUser,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';


function DesknavBar(props) {

  const navigate = useNavigate();
  const isAuthenticated = props.auth ? true : false;
  const userDetails = props.userDetails || {};
  const [dropdownOpen, setDropdownOpen] = useState(false);


  const navigateTo = (path) => {
    if (isSameSite(path)) {
      navigate(path);
    } else {
      window.location.href = getAbsoluteUrl(path);
    }
    setDropdownOpen(false);
  };



  const handleNextButtonClick = () => {
    if (isAuthenticated) {
      // Navigate based on user role
      if (userDetails?.role === 'Admin' || userDetails?.isAdmin === true) {
        navigateTo("/admin");
      } else {
        navigateTo("/dashboard");
      }
    } else {
      navigateTo("/login");
    }
    console.log("handleNext button clicked")
  };

  const handleLogout = async () => {
    await signOut(auth);
  };


  // Cleanup on unmount
  useEffect(() => {
    return () => {
      // Ensure dropdown is closed on unmount
      setDropdownOpen(false);
    };
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if we have a valid event target and it's not within the dropdown
      if (event && event.target && !event.target.closest('.dropdown')) {
        setDropdownOpen(false);
      }
    };

    // Only add event listener when dropdown is open
    if (dropdownOpen) {
      // Add a small delay to prevent immediate closure
      const timer = setTimeout(() => {
        document.addEventListener('click', handleClickOutside);
      }, 10);

      return () => {
        clearTimeout(timer);
        // Safe removal with try-catch
        try {
          document.removeEventListener('click', handleClickOutside);
        } catch (error) {
          // Silently handle removal errors
        }
      };
    }
  }, [dropdownOpen]);

  return (
    <div className={styles.stickyTopnav}>
      <div className={styles.navBar}>
        <a className={styles.navBarBrand} href="/"><img src="/static_img/weblogo.png" alt="logo" /> </a>
        <div className={styles.navs}>

          {/* <li className={styles.navItem}>
            <SmartLink className={styles.navLink} to="/">
              <div className={styles.navText}> Home</div>
            </SmartLink>
          </li>
          <li className={styles.navItem}>
            <SmartLink className={styles.navLink} to="/about">
              <div className={styles.navText}>About</div>
            </SmartLink>
          </li>

          <li className={styles.navItem}>
            <SmartLink className={styles.navLink} to="/learning">
              <div className={styles.navText}>Learning</div>
            </SmartLink>
          </li>

          < li className={styles.navItem}>
            <SmartLink className={styles.navLink} to="/notice">
              <div className={styles.navText}>Notice</div>
            </SmartLink>
          </li>
          < li className={styles.navItem}>
            <SmartLink className={styles.navLink} to="/pricing">
              <div className={styles.navText}>Pricing</div>
            </SmartLink>
          </li>
          <li className={styles.navItem}>
            <SmartLink className={styles.navLink} to="/contact">
              <div className={styles.navText}>Contact</div>
            </SmartLink>
          </li> */}
          {/* <li className="nav-item mx-1" onClick={handleNextButtonClick}></li> */}
          <div onClick={isAuthenticated ? () => setDropdownOpen(!dropdownOpen) : handleNextButtonClick}>
            {isAuthenticated ? (
              <div className={styles.dropdown} >
                <div type="button" style={{ cursor: 'pointer' }}>
                  <div className={styles.userAvatar}>
                    {userDetails?.name
                      ? userDetails.name.charAt(0).toUpperCase()
                      : userDetails?.email
                        ? userDetails.email.charAt(0).toUpperCase()
                        : 'U'}
                  </div>
                </div>
                {
                  dropdownOpen && (
                    <div className={styles.dropdownMenu}>
                      {(userDetails?.role === 'Admin' || userDetails?.isAdmin === true) ? (
                        // Admin dropdown options
                        <>
                          <div className={styles.dropdownItem} onClick={() => navigateTo("/admin")} style={{ color: '#dc3545', fontWeight: '600' }}>
                            <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />Admin Dashboard
                          </div>
                          <div className={styles.dropdownDivider}></div>
                          <div className={styles.dropdownItem} onClick={() => navigateTo("/admin/profile")}>
                            <FontAwesomeIcon icon={faUser} className="me-2" />Admin Profile
                          </div>
                          <div className={styles.dropdownItem} onClick={handleLogout}>
                            <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> <span>Log Out</span>
                          </div>
                        </>
                      ) : (
                        // User is not an admin
                        <div style={{ padding: '12px', width: '220px', textAlign: 'center' }}>
                          <p style={{ color: '#dc3545', fontWeight: '600', fontSize: '14px', marginBottom: '8px' }}>
                            Access Denied
                          </p>
                          <p style={{ color: '#6c757d', fontSize: '12px', marginBottom: '12px' }}>
                            You do not have administrative access.
                          </p>
                          <a
                            href={window.location.hostname.includes("localhost") ? "http://localhost:3000/login" : "https://siliconlogix.in/login"}
                            style={{
                              display: 'block',
                              backgroundColor: '#007bff',
                              color: '#fff',
                              padding: '6px 12px',
                              borderRadius: '4px',
                              textDecoration: 'none',
                              fontSize: '12px',
                              fontWeight: '500',
                              marginBottom: '8px'
                            }}
                          >
                            Go to User Login
                          </a>
                          <div className={styles.dropdownDivider} style={{ margin: '8px 0' }}></div>
                          <div className={styles.dropdownItem} onClick={handleLogout} style={{ justifyContent: 'center' }}>
                            <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> <span>Log Out</span>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                }
              </div >
            ) : (
              <SmartLink className={styles.guestAvatar}>
                <i className="fas fa-user-circle"></i>
              </SmartLink>
            )}
          </div >
        </div>
      </div >

    </div >
  );
};

export default DesknavBar;
